import axios from 'axios';
import { LanguageObject } from '@/i18n';
import { Survey, SurveyParticipation, Question } from './SurveyUtils';
import { SubOrganization } from './SubOrganizationUtils';
import { Address } from './AddressUtils';

interface PointsOfService {
  id?: number;
  name: LanguageObject;
  survey: Partial<Survey>;
  surveyparticipation: Partial<SurveyParticipation>;
  question: Partial<Question>;
  suborganizations: Partial<SubOrganization>[];
  address: Address;
}

const api = {
  list: async (params?: {
    questionid?: number;
    surveyparticipationid?: number;
  }) => {
    const resp = await axios.get<PointsOfService[]>(
      '/pointsOfService/list.php',
      { params: params }
    );
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<PointsOfService>('/pointsOfService/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (pointsofservices: PointsOfService[]) => {
    const resp = await axios.post<number[]>('/pointsOfService/add.php', {
      pointsofservice: pointsofservices,
    });

    // modify the existing objects to have the new id's
    pointsofservices.forEach((pointsofservice, index) => {
      pointsofservice.id = resp.data[index];
    });

    return pointsofservices;
  },

  update: async (pointsofservice: Partial<PointsOfService>) => {
    await axios.post('/pointsOfService/update.php', pointsofservice);
  },

  remove: async (id: number) => {
    await axios.delete('/pointsOfService/delete.php', {
      params: { id: id },
    });
  },
};

export default {
  api,
};

export { PointsOfService };
